// ─── 🧾 «Segna pagato» sul campo da pagare, con la tendina del mezzo (19/10/2026) ──
//
// 🗣️ *«mi devi dare la possibilità di stabilire come hanno pagato, se borsellino, carta oppure
// contanti. Quindi una tendina su segna pagato»*. Il tocco registra l'incasso vero in Cassa: col
// borsellino scala il saldo del socio. La cifra si scrive solo se il listino non la diceva.

import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { MEZZI_DEL_CAMPO_DA_PAGARE, etichettaMetodo, type SchedaPrenotazione } from '@pmo/shared';
import { chiama } from '../../lib/api.js';
import { Guasto } from '../../components/pezzi.js';

type Mezzo = (typeof MEZZI_DEL_CAMPO_DA_PAGARE)[number];

export function SegnaPagato({
  bookingId,
  cents,
  chi,
  fatto,
}: {
  bookingId: string;
  cents: number | null;
  chi: string;
  fatto?: (dopo: SchedaPrenotazione) => void;
}): React.JSX.Element {
  const qc = useQueryClient();
  const [mezzo, setMezzo] = useState<Mezzo>('cash');
  const [euro, setEuro] = useState('');
  const cifra = cents ?? Math.round(Number(euro.replace(',', '.')) * 100);
  const valida = Number.isFinite(cifra) && cifra > 0;
  const segna = useMutation({
    meta: { fatto: `campo di ${chi} segnato pagato` },
    mutationFn: () =>
      chiama<SchedaPrenotazione>('POST', `/bookings/${bookingId}/court-due/paid`, {
        method: mezzo,
        ...(cents === null ? { amountCents: cifra } : {}),
      }),
    onSuccess: (dopo) => {
      qc.setQueryData(['prenotazione', bookingId], dopo);
      void qc.invalidateQueries({ queryKey: ['campi-da-pagare'] });
      fatto?.(dopo);
    },
  });
  return (
    <div className="azioni-caparra">
      {cents === null && (
        <label>
          Cifra (€){' '}
          <input inputMode="decimal" value={euro} onChange={(e) => setEuro(e.target.value)} size={6} />
        </label>
      )}
      <label>
        Pagato con{' '}
        <select value={mezzo} onChange={(e) => setMezzo(e.target.value as Mezzo)}>
          {MEZZI_DEL_CAMPO_DA_PAGARE.map((m) => (
            <option key={m} value={m}>
              {etichettaMetodo(m)}
            </option>
          ))}
        </select>
      </label>
      <button type="button" disabled={segna.isPending || !valida} onClick={() => segna.mutate()}>
        {segna.isPending ? 'Un attimo…' : 'Segna pagato'}
      </button>
      <Guasto errore={segna.error} />
    </div>
  );
}
